var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Cập nhật Media Link cho màn Home trên App",
        visible: _vm.dialogVisible,
        width: "800px",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        top: "10vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "mediaData",
          attrs: {
            "label-width": "120px",
            model: _vm.mediaData,
            "label-position": "left",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Tên media", prop: "mediaName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "Nhập tên mô tả" },
                model: {
                  value: _vm.mediaData.mediaName,
                  callback: function ($$v) {
                    _vm.$set(_vm.mediaData, "mediaName", $$v)
                  },
                  expression: "mediaData.mediaName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Media Link", prop: "linkMedia" } },
            [
              _c("el-input", {
                attrs: { placeholder: "nhập media link" },
                model: {
                  value: _vm.mediaData.linkMedia,
                  callback: function ($$v) {
                    _vm.$set(_vm.mediaData, "linkMedia", $$v)
                  },
                  expression: "mediaData.linkMedia",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { display: "inline-block" },
              attrs: { label: "Loại", prop: "mediaType" },
            },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "Chọn loại" },
                  model: {
                    value: _vm.mediaData.mediaType,
                    callback: function ($$v) {
                      _vm.$set(_vm.mediaData, "mediaType", $$v)
                    },
                    expression: "mediaData.mediaType",
                  },
                },
                _vm._l(_vm.mediaTypeList, function (item) {
                  return _c("el-option", {
                    key: item.key,
                    attrs: { value: item.key, label: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { display: "inline-block", float: "right" },
              attrs: { label: "Phạm vi", prop: "scopeType" },
            },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "Chọn phạm vi" },
                  model: {
                    value: _vm.mediaData.scopeType,
                    callback: function ($$v) {
                      _vm.$set(_vm.mediaData, "scopeType", $$v)
                    },
                    expression: "mediaData.scopeType",
                  },
                },
                _vm._l(_vm.mediaScopeList, function (item) {
                  return _c("el-option", {
                    key: item.key,
                    attrs: { value: item.key, label: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Kích hoạt", prop: "mediaActive" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.mediaData.mediaActive,
                    callback: function ($$v) {
                      _vm.$set(_vm.mediaData, "mediaActive", $$v)
                    },
                    expression: "mediaData.mediaActive",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: true } }, [_vm._v("Có")]),
                  _c("el-radio", { attrs: { label: false } }, [
                    _vm._v("Không"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Ghi chú", prop: "note" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 3,
                  placeholder: "Nhập ghi chú",
                },
                model: {
                  value: _vm.mediaData.note,
                  callback: function ($$v) {
                    _vm.$set(_vm.mediaData, "note", $$v)
                  },
                  expression: "mediaData.note",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.closeDialogByButton("mediaData")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _c("span", [_vm._v("Đóng")]),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "success",
                size: "medium",
                loading: _vm.loadingButton,
                mini: "",
              },
              on: {
                click: function ($event) {
                  return _vm.submitForm("mediaData")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-check" }),
              _c("span", [_vm._v("Lưu")]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }